/**
 * Get a real value by css var.
 */
export default (cssVar: string): string => {
  const style = getComputedStyle(document.body);

  return style.getPropertyValue(cssVar).trim();
};
